/* ============================================
   SEEK KEY — Transparent Header Controller v3
   ============================================ */

(function () {
  'use strict';

  // Activate on all pages
  var isHomepage =
    document.body.classList.contains('template-index') ||
    window.location.pathname === '/' ||
    window.location.pathname === '';

  var sectionHeader = document.querySelector('.section-header');
  if (!sectionHeader) return;

  document.body.classList.add('header-transparent');

  // On non-homepage, start in scrolled state immediately (solid bg)
  if (!isHomepage) {
    sectionHeader.classList.add('header--scrolled');
  }

  var SCROLL_THRESHOLD = window.innerWidth <= 749 ? 10 : 60;

  // Set header height as CSS variable
  var initialHeightSet = false;

  function updateHeaderHeight() {
    var h = sectionHeader.offsetHeight;
    document.documentElement.style.setProperty('--header-height-fixed', h + 'px');
    document.documentElement.style.setProperty('--header-height', h + 'px');

    // Set initial height ONCE — this prevents hero jitter on scroll
    if (!initialHeightSet) {
      document.documentElement.style.setProperty('--header-height-initial', h + 'px');
      initialHeightSet = true;
    }
  }

  // Scroll handler
  var ticking = false;

  function onScroll() {
    if (ticking) return;
    ticking = true;

    requestAnimationFrame(function () {
      // On non-homepage, always keep scrolled state
      if (!isHomepage) {
        if (!sectionHeader.classList.contains('header--scrolled')) {
          sectionHeader.classList.add('header--scrolled');
        }
        ticking = false;
        return;
      }

      var scrollY = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollY > SCROLL_THRESHOLD) {
        if (!sectionHeader.classList.contains('header--scrolled')) {
          sectionHeader.classList.add('header--scrolled');
          // Recalc height after transition (header shrinks)
          setTimeout(updateHeaderHeight, 450);
        }
      } else {
        if (sectionHeader.classList.contains('header--scrolled')) {
          sectionHeader.classList.remove('header--scrolled');
          setTimeout(updateHeaderHeight, 450);
        }
      }


      ticking = false;
    });
  }

  // Override Dawn's StickyHeader
  function overrideDawnSticky() {
    var el = document.querySelector('sticky-header');
    if (!el) return;

    if (el.onScrollHandler) {
      window.removeEventListener('scroll', el.onScrollHandler);
    }

    el.hide = function () {};
    el.reveal = function () {};
    el.reset = function () {};

    sectionHeader.classList.add('shopify-section-header-sticky');
    sectionHeader.classList.remove('shopify-section-header-hidden');
  }

  // Init
  function init() {
    updateHeaderHeight();
    overrideDawnSticky();

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateHeaderHeight, 150);
    });

    // A altura inicial era medida aqui, no DOMContentLoaded — antes das
    // webfonts assentarem, quando a linha do logo ainda mede 83px em vez de
    // 75. O valor ficava congelado (initialHeightSet) 20px maior que o header
    // real, e como o hero reserva exatamente --header-height-initial, essa
    // sobra virava banda morta acima da arte (145px reservados para 125px de
    // header no celular; 141 para 117 nas páginas internas).
    //
    // Remede depois que fonte e layout assentam — e então TRAVA. A trava é o
    // ponto central: a reserva do hero não pode acompanhar a barra de
    // plataformas recolhendo e reaparecendo ao rolar. Sem ela, o observer
    // abaixo media a barra no meio da animação e reescrevia a reserva quadro a
    // quadro (medido: 120 → 73 → 120px na volta ao topo, com o documento
    // crescendo 47px embaixo do dedo). É uma altura de partida, não um valor
    // vivo.
    //
    // Escopado ao mobile de propósito: no desktop a sobra é de outro tamanho e
    // tem outro dono (home 96/92, mas página interna 91/71) — corrigir junto
    // mudaria o desktop sem Quest pedindo.
    var reserveObserver = null;
    var reserveLocked = false;

    function lockReserve() {
      if (reserveLocked) return;
      reserveLocked = true;
      if (reserveObserver) {
        reserveObserver.disconnect();
        reserveObserver = null;
      }
    }

    function remeasureWhenSettled() {
      if (reserveLocked) return;
      if (window.innerWidth > 989) return;
      // Na home o header COMPACTA ao rolar (a fileira de plataformas recolhe):
      // medir com a página rolada gravaria a altura do estado compacto como
      // reserva do hero e puxaria a arte para debaixo do header.
      if (isHomepage && (window.pageYOffset > 0 || sectionHeader.classList.contains('header--scrolled'))) return;
      initialHeightSet = false;
      updateHeaderHeight();
    }

    // 800ms depois do load a fonte já assentou em qualquer cenário medido
    // aqui; daí em diante a reserva não muda mais sozinha.
    function settleThenLock() {
      remeasureWhenSettled();
      setTimeout(lockReserve, 800);
    }
    // `load` já pode ter disparado quando este init roda (script adiado, ou
    // re-execução numa navegação de section rendering). Nesse caso o listener
    // nunca chamaria settleThenLock, o lock nunca seria agendado e o observer
    // abaixo ficaria vivo indefinidamente — que é justamente o shift de 47px
    // que esta quest existe pra matar (abrir a busca no topo da home recolhe a
    // fileira e reescreveria a reserva do hero).
    if (document.readyState === 'complete') {
      settleThenLock();
    } else {
      window.addEventListener('load', settleThenLock);
    }
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(remeasureWhenSettled).catch(function () {});
    }
    // Quem rola antes disso trava a reserva no valor que valia no topo: a
    // partir do primeiro scroll qualquer mudança de altura do header é a
    // animação da barra, não o layout assentando.
    window.addEventListener('scroll', function () {
      if (window.pageYOffset > 0) lockReserve();
    }, { passive: true });

    // `load` e `fonts.ready` disparam cedo demais em algumas páginas (a fonte
    // resolve, mas o layout do header só assenta no quadro seguinte — medido:
    // 125px em vez de 112 na coleção). O observer cobre essa janela, e só ela:
    // some assim que a reserva trava.
    if (window.ResizeObserver) {
      reserveObserver = new ResizeObserver(remeasureWhenSettled);
      reserveObserver.observe(sectionHeader);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
